import { Api } from "~/api";

export const getBaltexSections = (reset = false) => {
  return async (dispatch) => {
    const { ITEMS } = await Api.server.getBaltexSections(reset);
    dispatch({ type: "SET_BALTEX_SECTIONS", payload: ITEMS });
  };
};
